import { IDocumentModel } from "./../interfaces/document-model";
import { GenericTabModel } from "./tabs/generic-tab";
import { prop } from "../../decorators/property";
import { ParagraphFilterModel } from "../../desktop/models/paragraph-filter";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { QueryComponentModel } from "../../search/models/query-component";
import { QueryComponentsCollection } from "../../search/collections/query-components";

export enum ViewMode {
    Analysis,
    FullText,
    Precedentmap,
    Blank,
    Trendinggraph
}
export enum FullTextMode {
    Text,
    Pdf
}

export interface ISortOptions {
    SortArray: string[];
    CollectionType: string;
}

type NavBarPosition = "left" | "right";

@backboneModelProperties({
    idAttribute: "Id",
    defaults: {
        Section: "overview"
    }
})
export class DocumentStateModel extends Backbone.AssociatedModel {

    public static highlightColors: string[] = ["blue", "yellow", "pink", "green"];

    @prop() public ViewMode: ViewMode = ViewMode.Analysis;
    /** Current analysis Section. If you update this, it will update the URL and the UI */
    @prop() public CurrentAnalysisSection: GenericTabModel;
    /** Current fulltext Section. If you update this, it will update the URL and the UI */
    @prop() public CurrentFulltextSection: GenericTabModel;
    /** The most recently clicked on/viewed tab - this is needed for knowing which is active when we're in compact mode */
    @prop() public ActiveTab: GenericTabModel;
    @prop() public Document: IDocumentModel;
    @prop() public AnalysisTabNeedsScroll = false;
    @prop() public AnalysisNavBarPosition: NavBarPosition = "left";
    @prop() public FulltextTabNeedsScroll = false;
    @prop() public FulltextNavBarPosition: NavBarPosition = "left";

    constructor(document: IDocumentModel, options?) {
        super(options);
        this.Document = document;
        this.listenTo(this, "change:CurrentAnalysisSection", this.sectionChanged);
        this.listenTo(this, "change:CurrentFulltextSection", this.sectionChanged);
        this.listenTo(this, "change:ViewMode", this.viewModeChanged);
    }

    public showAnalysis() {
        this.ViewMode = ViewMode.Analysis;
    }

    public showFulltext() {
        this.ViewMode = ViewMode.FullText;
    }

    public resetViewMode() {
        this.ViewMode = null;
    }

    /**
     * Flip between analysis and fulltext mode. If we are not in one of these modes then do nothing.
     */
    public flip() {
        if (this.ViewMode === ViewMode.Analysis) {
            this.ViewMode = ViewMode.FullText;
        } else {
            if (this.ViewMode === ViewMode.FullText || this.ViewMode === ViewMode.Trendinggraph) { // tending graph is basic
                this.ViewMode = ViewMode.Analysis;
            }
        }
    }

    /**
     * Awaken the tab again to ensure it gets set to visible, even though it hasn't changed. This is important when switching between stages and switching back
     */
    public reactivateCurrentFulltextTab() {
        this.trigger("change:CurrentFulltextSection", this, this.CurrentFulltextSection, {});
    }

    /**
     * Awaken the tab again to ensure it gets set to visible, even though it hasn't changed. This is important when switching between stages and switching back
     */
    public reactivateCurrentAnalysisTab() {
        this.trigger("change:CurrentAnalysisSection", this, this.CurrentAnalysisSection, {});
    }

    public viewModeChanged() {
        if (this.ViewMode === ViewMode.Analysis) {
            this.ActiveTab = this.CurrentAnalysisSection;
        } else {
            this.ActiveTab = this.CurrentFulltextSection;
        }
    }

    public sectionChanged(tab) {
        if (!tab) {
            return;
        }
        this.ActiveTab = tab;
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/document-state.ts